
export const reactSelectStyles = {
    control: (baseStyles, state) => ({
        ...baseStyles,
        backgroundColor: "#dbeae3",
        border: "1px solid #dbeae3",
        width: "100%"
    }),
}